import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
export const useClinicStore = (storage) => create()(persist((set, get) => ({
    clinics: [],
    clinic: undefined,
    cityTree: {},
    clinicId: '',
    setClinicTree: (clinics) => {
        const cityTree = clinics.reduce((acc, clinic) => {
            const city = clinic.address?.city;
            return {
                ...acc,
                [city]: acc[city] ? [...acc[city], clinic] : [clinic],
            };
        }, {});
        set(() => ({ cityTree }));
    },
    setClinics: (clinics) => {
        set(() => ({ clinics }));
        get().setClinicTree(clinics);
    },
    setClinicId: (clinicId) => set(() => ({ clinicId })),
    setClinic: (clinic) => {
        set(() => ({ clinic: clinic }));
    },
    resetClinicStore: () => set(() => ({
        clinic: undefined,
        cityTree: {},
        clinicId: '',
    })),
    getClinic: (shortId) => {
        const clinics = get().clinics;
        return clinics.find((clinic) => clinic.shortId === shortId);
    },
}), {
    name: 'clinicStore',
    storage: createJSONStorage(() => storage || sessionStorage),
}));
